import type { ScheduleTime } from '@src/core/buyerApiClient';

interface Params {
  isWithDateAndTime: boolean;
  time?: ScheduleTime;
}

export function isRescheduleStepComplete({ isWithDateAndTime, time }: Params): boolean {
  return !(isWithDateAndTime && !time);
}
